import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { translations } from "@/i18n";
import { deepMerge } from "@/lib/content";
import { api } from "@/lib/api";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("gca_lang") || "de");
  const [overrides, setOverrides] = useState({});

  const loadContent = useCallback(() => {
    api.get("/content").then((r) => setOverrides(r.data || {})).catch(() => {});
  }, []);

  useEffect(() => { loadContent(); }, [loadContent]);

  useEffect(() => {
    const onFocus = () => loadContent();
    const onVis = () => { if (document.visibilityState === "visible") loadContent(); };
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVis);
    return () => { window.removeEventListener("focus", onFocus); document.removeEventListener("visibilitychange", onVis); };
  }, [loadContent]);

  const toggle = useCallback(() => {
    setLang((prev) => {
      const next = prev === "de" ? "en" : "de";
      localStorage.setItem("gca_lang", next);
      return next;
    });
  }, []);

  const t = deepMerge(translations[lang], overrides[lang] || {});

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t, overrides, reloadContent: loadContent }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
